// PDFGenerator.jsx
import { useRef, forwardRef, useImperativeHandle, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import PDFPreviewPage from './PDFPreviewPage';

const PDFGenerator = forwardRef(({ registrationData }, ref) => {
  const pdfRef = useRef();
  const [isGenerating, setIsGenerating] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = useReactToPrint({
    content: () => pdfRef.current,
    pageStyle: `
      @page {
        size: A4;
        margin: 0;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
        }
      }
    `,
    documentTitle: `Registration_${registrationData?.personalInfo?.firstName || 'Document'}`,
    onBeforeGetContent: () => {
      setIsGenerating(true);
      setIsDownloaded(false);
      setError(null);
      return Promise.resolve();
    },
    onAfterPrint: () => {
      setIsGenerating(false);
      setIsDownloaded(true);
      setTimeout(() => setIsDownloaded(false), 3000);
    },
    onPrintError: (error) => {
      console.error('PDF generation error:', error);
      setError('Failed to generate PDF. Please try again.');
      setIsGenerating(false);
    }
  });

  useImperativeHandle(ref, () => ({
    generatePDF: () => {
      if (!pdfRef.current) {
        setError('PDF content not ready');
        return Promise.reject('PDF content not ready');
      }
      return handleDownload();
    },
    isGenerating,
    isDownloaded,
    error
  }));

  return (
    <div style={{ display: 'none' }}>
      <div ref={pdfRef}>
        <PDFPreviewPage registrationData={registrationData} />
      </div>
    </div>
  );
});

PDFGenerator.displayName = 'PDFGenerator';

export default PDFGenerator;